module.exports = __webpack_public_path__ + "img/rav4-19.206dbf4c.jpg";